import { useMemo } from "react";
import { useLang } from "@/lib/i18n";
import QuizEngine from "@/components/games/QuizEngine";

const BANK = [
  { q: { en: "How many legs does a spider have?", zh: "蜘蛛有几条腿？" }, options: { en: ["6", "8", "10"], zh: ["6", "8", "10"] }, answer: 1 },
  { q: { en: "Which planet do we live on?", zh: "我们住在哪颗行星上？" }, options: { en: ["Mars", "Earth", "Jupiter"], zh: ["火星", "地球", "木星"] }, answer: 1 },
  { q: { en: "What do bees make?", zh: "蜜蜂会制造什么？" }, options: { en: ["Milk", "Honey", "Bread"], zh: ["牛奶", "蜂蜜", "面包"] }, answer: 1 },
  { q: { en: "Which animal is the tallest?", zh: "哪种动物最高？" }, options: { en: ["Giraffe", "Horse", "Dog"], zh: ["长颈鹿", "马", "狗"] }, answer: 0 },
  { q: { en: "What color do you get mixing blue and yellow?", zh: "蓝色和黄色混合会变成什么颜色？" }, options: { en: ["Green", "Purple", "Orange"], zh: ["绿色", "紫色", "橙色"] }, answer: 0 },
  { q: { en: "How many days are in a week?", zh: "一周有几天？" }, options: { en: ["5", "7", "10"], zh: ["5", "7", "10"] }, answer: 1 },
  { q: { en: "What do plants need to grow?", zh: "植物生长需要什么？" }, options: { en: ["Sunlight & water", "Candy", "Darkness"], zh: ["阳光和水", "糖果", "黑暗"] }, answer: 0 },
  { q: { en: "Which is the largest ocean?", zh: "哪个海洋最大？" }, options: { en: ["Atlantic", "Pacific", "Indian"], zh: ["大西洋", "太平洋", "印度洋"] }, answer: 1 },
  { q: { en: "What season comes after winter?", zh: "冬天之后是哪个季节？" }, options: { en: ["Summer", "Spring", "Autumn"], zh: ["夏天", "春天", "秋天"] }, answer: 1 },
  { q: { en: "What do we call frozen water?", zh: "结冰的水叫什么？" }, options: { en: ["Steam", "Ice", "Sand"], zh: ["蒸汽", "冰", "沙子"] }, answer: 1 },
];

function shuffle(a) {
  const arr = [...a];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function KnowledgeQuiz({ onFinish }) {
  const { code } = useLang();
  const questions = useMemo(() => {
    return shuffle(BANK).slice(0, 8).map((item) => ({
      prompt: item.q[code],
      options: item.options[code],
      answer: item.answer,
    }));
  }, [code]);
  return <QuizEngine questions={questions} onFinish={onFinish} />;
}
